import axios, { AxiosInstance } from "axios";
import User from "./User";

const Api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_WIDEOPRAWNIK_API,
});

function setToken() {
  const token = localStorage.getItem("token");
  if (token) {
    Api.defaults.headers.common["Authorization"] = "Bearer " + token;
  }
}

setToken();

Api.interceptors.response.use(undefined, function (error) {
  if (error?.response?.status === 403) {
    User.logout();
    return false;
  }
  return Promise.reject(error);
});

export default Api;
export { setToken };
